import React from 'react';
import { Image } from 'lucide-react';
import AdminCRUD from '../../components/admin/AdminCRUD';

export default function AdminGallery() {
  return (
    <AdminCRUD
      endpoint="gallery"
      title="Gallery"
      icon={Image}
      columns={[
        { key:'title', label:'Media', render:(v,item) => (
          <div className="flex items-center gap-3">
            {item.url
              ? <img src={item.thumbUrl||item.url} alt={v} className="w-12 h-12 rounded-xl object-cover flex-shrink-0" />
              : <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center text-gray-400 text-xl flex-shrink-0">🖼</div>}
            <div>
              <div className="font-semibold text-gray-900 text-sm">{v}</div>
              <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${item.type==='video'?'bg-blue-100 text-blue-700':'bg-gold-100 text-gold-700'}`}>{item.type||'photo'}</span>
            </div>
          </div>
        )},
        { key:'category', label:'Category', render: v => v || '—' },
        { key:'isPublished', label:'Live', render: v => v ? <span className="text-emerald-500 font-bold">✓</span> : <span className="text-gray-300">—</span> },
        { key:'createdAt', label:'Added', render: v => <span className="text-xs text-gray-400">{new Date(v).toLocaleDateString('en-NG')}</span> },
      ]}
      defaultForm={{ title:'', description:'', url:'', type:'photo', category:'', isPublished:true }}
      formFields={[
        { key:'image', label:'Upload Image', type:'image', fullWidth:true },
        // { key:'type', label:'Media Type', type:'select', options:['photo','video'] },
        { key:'category', label:'Category / Event' },
        { key:'title', label:'Title', required:true },
        { key:'description', label:'Description', type:'textarea', fullWidth:true },
        { key:'tags', label:'Tags (comma-separated)', fullWidth:true },
        { key:'isPublished', label:'Publish', type:'checkbox', checkLabel:'Show in public gallery', fullWidth:true },
      ]}
    />
  );
}
